import { io } from 'socket.io-client'
import store from '@/store'



let socket = null



export function connectSocket(token) {
  if(store.state.user.isLoggedIn) {
    socket = io('https://wxchecker.xyz', { auth: { token } } )
    // socket = io('https://172.22.0.2:8081', { auth: { token } } )
  }
}



export function getSocket() {
  if(!socket) {
    console.log('Socket Error!')
  }
  return socket
}



export function disconnectSocket() {
  if(socket) {
    socket.disconnect()
    console.log('Socket disconnected')
    socket = null
  }
}